import React from "react";

const InfoBanner = (props) => {
  const { infoType } = props;
  let infoBannerText = null;
  if (props.infoText && props.infoText.trim() !== "") {
    if (infoType === "welcomeBack") {
      infoBannerText = (
        <div className="[ container-fluid ] [ info-banner ] [ welcome-back ]">
          <span className="[ info-banner__text ]">{props.infoText}</span>
        </div>
      );
    } else {
      infoBannerText = (
        <div className="[ container-fluid ] [ info-banner ]">
          <span className="[ info-banner__lock-icon ]" />
          <span className="[ info-banner__text ]">{props.infoText}</span>
        </div>
      );
    }
  }
  return infoBannerText;
};

export default InfoBanner;
